export default __webpack_public_path__ + "static/media/CO.092544dd.svg";